/**
 * Tool result query operations - Create
 */

import { v4 as uuidv4 } from 'uuid';
import type { ChatId, UserId } from '../../types.js';
import { getSupabaseClient } from '../../supabase-client.js';
import type { StoredToolResultSummary } from '../types.js';
import { logger } from '../../../logger.js';

/**
 * Create a tool result summary
 */
export async function createToolResult(
  summary: Omit<StoredToolResultSummary, 'id' | 'created_at' | 'updated_at'>
): Promise<StoredToolResultSummary> {
  try {
    const client = getSupabaseClient();
    const now = new Date().toISOString();

    const { data, error } = await client
      .from('meridian_tool_results')
      .insert({
        id: uuidv4(),
        chat_id: summary.chat_id,
        user_id: summary.user_id,
        tool_name: summary.tool_name,
        tool_call_id: summary.tool_call_id,
        result_summary: summary.result_summary,
        result_type: summary.result_type,
        execution_time: summary.execution_time,
        input_size: summary.input_size,
        output_size: summary.output_size,
        executed_at: summary.executed_at,
        summarized_at: summary.summarized_at,
        created_at: now,
        updated_at: now,
      })
      .select()
      .single();

    if (error) {
      throw error;
    }

    return data as StoredToolResultSummary;
  } catch (error) {
    logger.error('error creating tool result', error, { op: 'createToolResult' });
    throw error;
  }
}
